import {
  AF_CAREER_RESOURCES_LINK,
  AF_LINK,
  ONE_T_ORG_LINK,
  TES_NATIONAL_EXPLORER_ABOUT_LINK,
  TES_NATIONAL_EXPLORER_CONTACT_LINK,
  TES_NATIONAL_EXPLORER_METHODOLOGY_LINK,
  TES_NATIONAL_EXPLORER_STORIES_LINK,
  TES_NATIONAL_EXPLORER_DATA_GLOSSARY_LINK,
  TES_NATIONAL_EXPLORER_FAQ_LINK,
  TES_NATIONAL_EXPLORER_DATA_DOWNLOAD_LINK,
  TES_NATIONAL_EXPLORER_DEMO_LINK,
  TES_NATIONAL_EXPLORER_STARTER_GUIDE_LINK,
  TES_NATIONAL_EXPLORER_RESOURCES_TAB_LINK,
  VIBRANT_CITIES_LAB_LINK,
  TES_UK_NATIONAL_EXPLORER_HOME_LINK,
} from "app/constants"
import { Routes } from "@blitzjs/next"
import { useRouter } from "next/router"
import Link from "next/link"
import { CITIES } from "app/features/regional-map/regional-map.constants"
import { TesLogo } from "./tes_logo"
import { clearMapPositionSessionStorage } from "hooks/use_map"

const MORE = [
  {
    name: "About Tree Equity Score",
    link: TES_NATIONAL_EXPLORER_ABOUT_LINK,
  },
  {
    name: "Methods",
    link: TES_NATIONAL_EXPLORER_METHODOLOGY_LINK,
  },
  {
    name: "Data Glossary",
    link: TES_NATIONAL_EXPLORER_DATA_GLOSSARY_LINK,
  },
  {
    name: "FAQs",
    link: TES_NATIONAL_EXPLORER_FAQ_LINK,
  },
  {
    name: "Data Download",
    link: TES_NATIONAL_EXPLORER_DATA_DOWNLOAD_LINK,
  },
  {
    name: "Stories",
    link: TES_NATIONAL_EXPLORER_STORIES_LINK,
  },
  {
    name: "Watch the Demo",
    link: TES_NATIONAL_EXPLORER_DEMO_LINK,
  },
  {
    name: "Starter Guide",
    link: TES_NATIONAL_EXPLORER_STARTER_GUIDE_LINK,
  },
  {
    name: "More Resources",
    link: TES_NATIONAL_EXPLORER_RESOURCES_TAB_LINK,
  },
  {
    name: "Contact Us",
    link: TES_NATIONAL_EXPLORER_CONTACT_LINK,
  },
]

const RESOURCES = [
  {
    name: "Vibrant Cities Lab",
    link: VIBRANT_CITIES_LAB_LINK,
  },
  {
    name: "1T.org",
    link: ONE_T_ORG_LINK,
  },
  {
    name: "Career Resources",
    link: AF_CAREER_RESOURCES_LINK,
  },
]

// sort cities alphabetically
CITIES.sort((a, b) => a.title.localeCompare(b.title))

export default function Footer() {
  const router = useRouter()
  return (
    <div
      className="bg-[#ECF5F2]"
      style={{
        backgroundImage: "url(/tes-footer-gradient.jpg)",
        backgroundSize: "cover",
        backgroundPosition: "top center",
        backgroundRepeat: "no-repeat",
        imageRendering: "crisp-edges",
      }}
    >
      <div className="m-auto grid w-11/12 grid-cols-3 gap-6 pb-16 pt-36 md:grid-cols-5 md:gap-10 lg:w-4/5 lg:grid-cols-6">
        <div>
          <h2 className="pb-3 text-lg font-bold text-brand-green-dark">National Explorer</h2>
          <button
            onClick={() => {
              clearMapPositionSessionStorage()
              router.push(Routes.NationalExplorer())
            }}
          >
            <a className="text-sm text-brand-green-dark decoration-[#f9c793] decoration-4 underline-offset-4 hover:underline">
              Explore the map
            </a>
          </button>
        </div>
        <div>
          <h2 className="pb-3 text-lg font-bold text-brand-green-dark">Local Analyzers</h2>
          {CITIES.filter((city) => city.id != "national").map((city, i) => {
            return (
              <Link key={i} href={Routes.LandingPage({ city: city.id })}>
                <div className="pb-1.5 text-sm text-brand-green-dark decoration-[#f9c793] decoration-4 underline-offset-4 hover:underline">
                  {city.title}
                </div>
              </Link>
            )
          })}
          <Link
            href="/analyzer"
            className="text-sm text-brand-green-dark decoration-[#f9c793] decoration-4 underline-offset-4 hover:underline"
          >
            Learn about Analyzers
          </Link>
        </div>
        <div>
          <h2 className="pb-3 text-lg font-bold text-brand-green-dark">International</h2>
          <Link href={TES_UK_NATIONAL_EXPLORER_HOME_LINK} className="text-sm">
            <div className="pb-1.5 text-brand-green-dark decoration-[#f9c793] decoration-4 underline-offset-4 hover:underline">
              UK
            </div>
          </Link>
        </div>
        <div>
          <h2 className="pb-3 text-lg font-bold text-brand-green-dark">More</h2>
          {MORE.map((item, i) => {
            return (
              <Link key={i} href={`${item.link}`} className="text-sm">
                <div className="pb-1.5 text-brand-green-dark decoration-[#f9c793] decoration-4 underline-offset-4 hover:underline">
                  {item.name}
                </div>
              </Link>
            )
          })}
        </div>
        <div>
          <h2 className="pb-3 text-lg font-bold text-brand-green-dark">Resources</h2>
          {RESOURCES.map((item, i) => {
            return (
              <Link
                key={i}
                href={`${item.link}`}
                className="text-sm"
                target="_blank"
                rel="noreferrer noopener"
              >
                <div className="pb-1.5 text-brand-green-dark decoration-[#f9c793] decoration-4 underline-offset-4 hover:underline">
                  {item.name}
                </div>
              </Link>
            )
          })}
        </div>
        <div className="col-span-3 text-center text-lg font-bold text-slate-700 md:col-span-1">
          <Link
            href="https://give.americanforests.org/ways-to-give/donate-now/"
            target="blank"
            rel="noreferrer noopener"
            className="inline-block rounded-full bg-brand-green px-[1.75rem] py-2.5 transition duration-500 ease-in-out hover:bg-[#005251] hover:text-white"
          >
            Donate
          </Link>
          <h2 className="pb-1 pt-10">Connect</h2>
          <div className="flex">
            <Link
              href="http://twitter.com/AmericanForests"
              target="blank"
              rel="noreferrer noopener"
            >
              <img
                alt=""
                src="/icons/social-twitter.svg"
                className="rounded-full hover:bg-brand-green"
              />
            </Link>
            <Link
              href="http://facebook.com/AmericanForests"
              target="blank"
              rel="noreferrer noopener"
            >
              <img
                alt=""
                src="/icons/social-facebook.svg"
                className="rounded-full hover:bg-brand-green"
              />
            </Link>
            <Link
              href="http://instagram.com/AmericanForests"
              target="blank"
              rel="noreferrer noopener"
            >
              <img
                alt=""
                src="/icons/social-instagram.svg"
                className="rounded-full hover:bg-brand-green"
              />
            </Link>
            <Link
              href="https://www.linkedin.com/company/american-forests/"
              target="blank"
              rel="noreferrer noopener"
            >
              <img
                alt=""
                src="/icons/social-linkedin.svg"
                className="rounded-full hover:bg-brand-green"
              />
            </Link>
          </div>
        </div>
        <div className="col-span-3 m-auto gap-x-4 lg:col-span-2">
          <TesLogo className="m-auto inline w-28 md:ml-0" />
          <Link href={AF_LINK}>
            <img src="/af-logo.svg" className="m-auto inline w-48 md:ml-0" />
          </Link>
          <p className="pl-2 pt-2 text-xs text-gray-600">
            Made possible with tree canopy provided by{" "}
            <img className="inline h-6" src="/google.png" />
          </p>
        </div>
        <div className="col-span-3 text-center leading-relaxed text-brand-green-dark md:col-span-1 md:text-right lg:col-span-2">
          <p className="text-sm font-semibold">American Forests</p>
          <p className="text-sm">
            1220 L Street, NW,
            <br />
            Suite 750
            <br />
            Washington, DC 20005
          </p>
        </div>
        <div className="col-span-3 text-xs leading-relaxed text-gray-600 md:col-span-5 lg:col-span-2">
          American Forests is a nonprofit, tax-exempt charitable organization under Section
          501(c)(3) of the U.S. Internal Revenue Code. Donations are tax-deductible as allowed by
          law.
          <br />
          <br />
          Copyright © {new Date().getFullYear()} American Forests. All Rights Reserved.
          <p></p>
          <Link href="/privacy" className="text-brand-green-dark">
            Privacy Policy.
          </Link>{" "}
          <Link href="/manage-tracking" className="text-brand-green-dark">
            Manage Tracking Preferences.
          </Link>
        </div>
      </div>
    </div>
  )
}
